import { State } from '@/store/store'
import { IPatient } from '../patient/states'

export class MonthlyContractState {
  public list: MonthlyContractList
  public create: object
  public update: object
  public delete: object

  constructor() {
    this.list = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
    this.create = {}
    this.update = {}
    this.delete = {}
  }
}
export interface MonthlyContractList {
  column: Array<{
    text: string
    value: string
    type?: string
    options?: {
      orderable?: boolean
      lengthLimit?: number
      filter?: boolean
      operation: string[],
    },
  }>
  defaultFilter: object
  itemCount: number
  page: number
  pageCount: number
  result: IMonthlyContract[]
}
export interface IMonthlyContract {
  _id?: string,
  patientDetail?: IPatient,
  patientId: string,
  centerId: string,
  jobId: string,
  startDate: string,
  endDate: string,
  contract: string,
  price: number,
}

export default MonthlyContractState
